package org.zq.astrock_ai.ui.research.gushi.data

import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.zq.astrock_ai.storage.ResearchKvStorage
import org.zq.astrock_ai.util.currentTimeMillis

@Serializable
data class PaperTradeEntry(
    val atMs: Long,
    val code: String,
    val name: String = "",
    val side: String, // BUY / SELL
    val price: Double = 0.0,
    val reason: String = "",
    val source: String = "scan", // scan | quant | manual
    /** 成交股数；0 表示沿用入仓时手数设置 */
    val quantity: Int = 100,
    val note: String = "",
)

object PaperTradeStore {
    private const val KEY = "paper.trades.v1"
    private const val MAX = 80
    private val json = Json { ignoreUnknownKeys = true; encodeDefaults = true }

    fun load(): List<PaperTradeEntry> =
        runCatching {
            val raw = ResearchKvStorage.get(KEY) ?: return emptyList()
            json.decodeFromString<List<PaperTradeEntry>>(raw)
        }.getOrDefault(emptyList())

    fun append(entry: PaperTradeEntry) {
        val next = (listOf(entry) + load()).take(MAX)
        ResearchKvStorage.put(KEY, json.encodeToString(next))
    }

    fun appendSignal(
        code: String,
        name: String,
        side: String,
        price: Double,
        reason: String,
        source: String,
        quantity: Int = 100,
        note: String = "",
    ) {
        if (side != "BUY" && side != "SELL") return
        append(
            PaperTradeEntry(
                atMs = currentTimeMillis(),
                code = code,
                name = name,
                side = side,
                price = price,
                reason = reason.take(80),
                source = source,
                quantity = quantity.coerceAtLeast(0),
                note = note.take(40),
            ),
        )
    }

    fun updateNote(atMs: Long, code: String, side: String, note: String) {
        val next = load().map { e ->
            if (e.atMs == atMs && e.code == code && e.side == side) {
                e.copy(note = note.take(40))
            } else {
                e
            }
        }
        ResearchKvStorage.put(KEY, json.encodeToString(next))
    }
}
